/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const NDC_ERROR_POPUP_MESSAGE = 'NDC_ERROR_POPUP_MESSAGE';
export const NDC_SUCCESS_MESSAGE = 'NDC_SUCCESS_MESSAGE';
export const NDC_SELECTED_NDC_TAB = 'NDC_SELECTED_NDC_TAB';

export const NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA =
  'NDC_SEARCH_BY_DRUG_NAME_TABLE_DATA';
export const NDC_LABELER_TABLE_DATA = 'NDC_LABELER_TABLE_DATA';
export const PRICE_TYPE_DETAILS = 'PRICE_TYPE_DETAILS';
export const NDC_LABELER_DRUG_TABLE_DATA = 'NDC_LABELER_DRUG_TABLE_DATA';
export const NDC_DETAILS_TABLE_DATA = 'NDC_DETAILS_TABLE_DATA';
export const NDC_DETAILS_TABLE_ROW_SELECTED = 'NDC_DETAILS_TABLE_ROW_SELECTED';
export const NDC_DETAILS = 'NDC_DETAILS';
export const NDC_LOADING = 'NDC_LOADING';
export const NDC_REFERENCE_DATA = 'NDC_REFERENCE_DATA';
export const NDC_DETAILS_TAB_SELECTED = 'NDC_DETAILS_TAB_SELECTED';
export const CURRENT_NDC_DETAILS_SELECTED = 'CURRENT_NDC_DETAILS_SELECTED';
export const CURRENT_NDC_DETAILS_INDEX = 'CURRENT_NDC_DETAILS_INDEX';
export const NDC_GENERAL_PARAMETERS = 'NDC_GENERAL_PARAMETERS';
export const RESET_NDC_DATA = 'RESET_NDC_DATA';
export const RESET_NDC_DETAILS_DATA = 'RESET_NDC_DETAILS_DATA';
export const SEARCH_BY_NDC_ID = 'SEARCH_BY_NDC_ID';
export const SET_NDC_SEARCH_BY_DRUG_NAME = 'SET_NDC_SEARCH_BY_DRUG_NAME';
